/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddFile as AgentApiContractAddFile } from '../../models/AgentApi/Contract/add-file';
import { LoadCardFileRequest as AgentApiContractLoadCardFileRequest } from '../../models/AgentApi/Contract/load-card-file-request';

export interface ApiAgentLoadCardFilePost$Params {

/**
 * system language
 */
  lang?: string;
  
    /**
     * Data to download
     */
    body?: AgentApiContractLoadCardFileRequest
}

export function apiAgentLoadCardFilePost(http: HttpClient, rootUrl: string, params?: ApiAgentLoadCardFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddFile>> {
  const rb = new RequestBuilder(rootUrl, apiAgentLoadCardFilePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractAddFile>;
    })
  );
}

apiAgentLoadCardFilePost.PATH = '/api/Agent/LoadCardFile';
